import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';

interface UseCreateClientUserExternalToken {
  clientUserId?: string;
  onSuccess?: (reponse: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useCreateClientUserExternalToken = ({ clientUserId, onSuccess, onError }: UseCreateClientUserExternalToken) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse, ErrorResponse>({
    mutationKey: ['createClientUserExternalToken', clientUserId],
    mutationFn: () => privateAxios.post(`/client/user_external_tokens`, {
      user_external_token: {
        user_id: clientUserId,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useCreateClientUserExternalToken;
